import type { NavigationUtils } from '@change-corgi/core/react/navigation';
import { createNavigationUtils as _createNavigationUtils } from '@change-corgi/core/react/navigation';

import { APP_ROUTES_REGEXPS_NON_ISOLATED } from 'src/app/routes';
import type { HydrationData } from 'src/app/types';

export function createNavigationUtils(hydrationData: HydrationData | undefined): NavigationUtils {
	return _createNavigationUtils({ internalRoutes: hydrationData?.isolated ? [] : APP_ROUTES_REGEXPS_NON_ISOLATED });
}
